<template>
  <div class="text-field-editor">
    <div class="form-group">
      <label for="content-fr">Texte en Français:</label>
      <input
        id="content-fr"
        type="text"
        :value="fieldData.content_fr"
        @input="updateField('content_fr', $event.target.value)"
        placeholder="Entrez le texte en français"
        class="form-control"
      />
    </div>

    <div class="form-group">
      <label for="content-en">Texte en Anglais:</label>
      <input
        id="content-en"
        type="text"
        :value="fieldData.content_en"
        @input="updateField('content_en', $event.target.value)"
        placeholder="Enter text in English"
        class="form-control"
      />
    </div>

    <div class="form-group">
      <label for="color-picker">Couleur du Texte:</label>
      <input
        id="color-picker"
        type="color"
        :value="fieldData.color"
        @input="updateField('color', $event.target.value)"
        class="form-color"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextFieldEditor',
  props: {
    fieldData: Object,
    fieldKey: String,
  },
  methods: {
    updateField(fieldName, value) {
      this.$emit('update-field', { key: this.fieldKey, fieldName, value });
    },
  },
};
</script>

<style scoped>
.text-field-editor {
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

label {
  font-size: 1rem;
  font-weight: 600;
  color: #333;
}

.form-control {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 1rem;
  width: 100%;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.form-control:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 4px rgba(0, 123, 255, 0.5);
}

.form-color {
  padding: 5px;
  border: none;
  border-radius: 8px;
  width: 60px;
  height: 40px;
  cursor: pointer;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  max-width: 400px;
}

.form-color:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}
</style>
